import {Deserializable} from './deserializable.model';

export class FXResponse<T> implements Deserializable {
  status: number;
  message: string;
  // tslint:disable-next-line:variable-name
  error_code: string;
  data: T;
  paging: any;
  range: any;
  metadata: any;

  deserialize(input: any): any {
    Object.assign(this, input);
    return this;
  }
}
